export const organizationKeys = {
  all: ['org'] as const,
  lists: () => [...organizationKeys.all, 'list'] as const,
  list: (orgId?: string) =>
    [...organizationKeys.lists(), orgId ?? 'all'] as const,
  includingInactive: () =>
    [...organizationKeys.lists(), 'including-inactive'] as const,
  details: () => [...organizationKeys.all, 'detail'] as const,
  detail: (id: string) => [...organizationKeys.details(), id] as const,
  // Per user: the answer differs between two admins of the same org (#2820).
  onboardingAccess: (orgId: string, userId: string | null) =>
    [...organizationKeys.all, 'onboarding-access', orgId, userId] as const,
}
